import { Component, HostListener } from "@angular/core";
import { ConsentService } from "src/services/consent-service";
import { CookieConsentType, Duration, ICookieSection } from "./interfaces";

const COOKIE_SECTIONS: ICookieSection[] = [
  {
    type: CookieConsentType.REQUIRED,
    cookies: [
      {
        name: "channelRequestId",
        service: "Internal",
        duration: [Duration.DAYS, 90],
      },
      {
        name: "consent_*",
        service: "Internal",
        duration: [Duration.YEARS, 1],
      },
      {
        name: "noCarOrDealerWarningClosed",
        service: "Internal",
        duration: [Duration.DAYS, 14],
      },
      {
        name: "BIGipServerSites_*",
        service: "BIGipServer",
        duration: [Duration.SESSION],
      },
    ]
  },
  {
    type: CookieConsentType.FUNCTIONAL,
    cookies: []
  },
  {
    type: CookieConsentType.PERFORMANCE,
    cookies: [
      {
        name: "_ga",
        service: "Google Analytics",
        duration: [Duration.DAYS, 400],
      },
      {
        name: "_ga_*",
        service: "Google Analytics",
        duration: [Duration.DAYS, 400],
      },
      {
        name: "_hjSessionUser_*",
        service: "Hotjar",
        duration: [Duration.YEARS, 1],
      },
      {
        name: "_hjSession_*",
        service: "Hotjar",
        duration: [Duration.DAYS, 14],
      },
    ],
  },
  {
    type: CookieConsentType.MARKETING,
  cookies: [
    {
      name: "_gcl_*",
      service: "Google Conversion Linker",
      duration: [Duration.DAYS, 90],
    },
  ] 
  }
]

@Component({
  selector: "vw-cookie-info-page",
  templateUrl: "./cookie-info-page.component.html",
})
export class CookieInfoPageComponent {
  constructor(private consentService: ConsentService) {}

  get cookieSections() {
    return COOKIE_SECTIONS;
  }

  @HostListener("click", ["$event"])
  onClick(ev: MouseEvent) {
    const { target } = ev;
    if (
      target instanceof HTMLAnchorElement &&
      target.dataset.action === "openCookieSettings"
    ) {
      ev.preventDefault();
      this.consentService.openConsentDialog();
    }
  }
}
